



































































































































































import Vue from 'vue'
import { vxm } from '@/state/'
// vetur (linter) complains about this next line, but it is OK. TODO: fix later
import cssVariablesJson from '@/styles/variables.json'

export default Vue.extend({
  name: 'Page',

  components: {
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    breadcrumb: {
      type: String,
      default: '',
    },
    // must be of type:
    /*
      const subPages = [
        { title: 'hello', nav: { name: 'apitest' } },
        { title: 'layout', nav: { name: 'layout' } },
      ]
      where the nav is an object that can be fed to router push
      TODO: make this typesave
    */
    subPages: {
      type: Array,
      default: () => [],
    },

  },
  data: () => ({
    // Please duplicate the color object in dev/layoutHelper.vue
    layoutHelpColors: {
      pageOuterContainer: 'yellow lighten-1',
      content: 'purple lighten-4',
      pageContentContainer: 'green lighten-3',
      pageMainRow: 'orange lighten-4',
      pageMainCol: 'blue lighten-4',
    },
    // use our font-family variable to in page title's :style attribute to overwrite
    // vuetify's default font. See explanation in docs.
    // eslint-disable-next-line max-len
    pageTitleFont: `font-family: ${cssVariablesJson['my-heading-font-family']} !important;`,
  }),
  computed: {
    showVisualDesignHelp() {
      return vxm.app.showVisualDesignHelp
    },
  },
  methods: {
    subPageNavigate(subPageIndex: number | string) {
      // @ts-ignore
      const { nav } = this.subPages[subPageIndex as number]
      this.$router.push(nav)
    },
  },
})
